/**
 * Represents the position and size of a dialog for persistence.
 */
export interface DialogPositionSize {
    readonly left?: string | null;
    readonly top?: string | null;
    readonly width?: string | null;
    readonly height?: string | null;
}
